'use client';

import type React from 'react';
import { createContext, useContext } from 'react';
import { useUserLocaleOverride } from './UserLocaleOverrideProvider';

export const LanguageContext = createContext<string | null>(null);

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  const { locale: localeOverride } = useUserLocaleOverride();

  if (context === null) {
    throw new Error('[useLanguageContext] is not wrapped inside a provider');
  }
  return localeOverride || context;
};

export function LanguageContextProvider({
  value,
  children,
}: {
  value: string;
  children: React.ReactNode;
}) {
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
